//#region src/shared/layout-constants.ts
const LAYOUT_COLS = 24;
const LAYOUT_BREAKPOINTS = {
	desktop: 1024,
	mobile: 1
};
/**
* Important: keep the same pdding for x and y.
*/
/**
* This is the height of a row in the layout grid.
*/
const LAYOUT_ROW_HEIGHT = 24;

//#endregion
export { LAYOUT_BREAKPOINTS, LAYOUT_COLS, LAYOUT_ROW_HEIGHT };
//# sourceMappingURL=layout-constants.js.map